import { useEffect, useState } from 'react'
import { UserPlus } from 'lucide-react'
import { cmsApi } from '../lib/api'
import { formatDateTime } from '../lib/format'
import type { CmsRole, CmsUser } from '../types'
import { LoadingState } from './LoadingState'

export function TeamPage({ currentUser }: { currentUser: CmsUser }) {
  const [users, setUsers] = useState<CmsUser[]>([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [email, setEmail] = useState('')
  const [role, setRole] = useState<CmsRole>('editor')
  const [error, setError] = useState('')

  const load = async () => {
    setLoading(true)
    try { setUsers(await cmsApi.listUsers()) }
    catch (requestError) { setError(requestError instanceof Error ? requestError.message : 'Não foi possível carregar a equipe.') }
    finally { setLoading(false) }
  }
  useEffect(() => { void load() }, [])

  const save = async (targetEmail: string, targetRole: CmsRole, active: boolean) => {
    setSaving(true); setError('')
    try { await cmsApi.saveUser(targetEmail, targetRole, active); setEmail(''); await load() }
    catch (requestError) { setError(requestError instanceof Error ? requestError.message : 'Não foi possível alterar o acesso.') }
    finally { setSaving(false) }
  }

  return (
    <div className="page-stack">
      <section className="page-heading"><h1>Equipe</h1><p>Somente e-mails autorizados podem entrar, mesmo usando uma conta Google válida.</p></section>
      <section className="panel team-invite">
        <div><div><h2>Autorizar uma pessoa</h2><p>O vínculo com a conta Google acontece no primeiro acesso.</p></div></div>
        <form onSubmit={(event) => { event.preventDefault(); void save(email.trim().toLowerCase(), role, true) }}>
          <label className="field"><span>E-mail Google</span><input type="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder="pessoa@gmail.com" /></label>
          <label className="field"><span>Permissão</span><select value={role} onChange={(event) => setRole(event.target.value as CmsRole)}><option value="editor">Editor</option><option value="viewer">Leitor</option><option value="owner">Proprietário</option></select></label>
          <button className="button button--primary" disabled={saving}><UserPlus size={17} /> Autorizar</button>
        </form>
        {error && <p className="form-error">{error}</p>}
      </section>
      <section className="panel panel--flush">
        <div className="panel__heading panel__heading--padded"><div><h2>Pessoas autorizadas</h2><p>{users.length} acessos cadastrados</p></div></div>
        {loading ? <LoadingState /> : <div className="table-wrap"><table><thead><tr><th>Pessoa</th><th>Permissão</th><th>Último acesso</th><th>Status</th><th /></tr></thead><tbody>{users.map((user) => <tr key={user.id}><td><strong>{user.email}</strong>{user.email === currentUser.email && <small>Você</small>}</td><td><select value={user.role} disabled={saving || user.email === currentUser.email} onChange={(event) => void save(user.email, event.target.value as CmsRole, user.is_active !== false)}><option value="owner">Proprietário</option><option value="editor">Editor</option><option value="viewer">Leitor</option></select></td><td>{formatDateTime(user.last_seen_at)}</td><td><span className={`access-pill ${user.is_active === false ? 'access-pill--off' : ''}`}>{user.is_active === false ? 'Inativo' : 'Ativo'}</span></td><td><button className="text-button" disabled={saving || user.email === currentUser.email} onClick={() => void save(user.email, user.role, user.is_active === false)}>{user.is_active === false ? 'Reativar' : 'Desativar'}</button></td></tr>)}</tbody></table></div>}
      </section>
    </div>
  )
}
